export type Environment = "msw" | "local" | "development" | "staging" | "production";

export interface EnvironmentVariables {
    aiApiBaseUrl: string;
    navigationApiBaseUrl: string;
    managementAppBaseUrl: string;
    // The Workleap platform app (wl-app). It deploys to staging and production only; local, dev and MSW builds of wl-app
    // run against staging, so those environments link there.
    wlAppBaseUrl: string;
    cdnBaseUrl: string;
    navigationBarEnvironment: Environment;
    loginPageUrl: string;
    intercomAppId: string;
    openTelemetryProxyUrl?: string;
    logRocketAppId?: string;
}

const MswEnvironmentVariables: EnvironmentVariables = {
    aiApiBaseUrl: "/api/ai",
    navigationApiBaseUrl: "/api/shell/navigation",
    managementAppBaseUrl: "https://management.workleap-dev.com",
    wlAppBaseUrl: "https://app.workleap-stg.com",
    cdnBaseUrl: "https://cdn.ai.workleap-dev.com",
    navigationBarEnvironment: "msw",
    loginPageUrl: "https://login.workleap-dev.com",
    intercomAppId: "gw56e358"
};

const LocalEnvironmentVariables: EnvironmentVariables = {
    aiApiBaseUrl: "https://local-api-ai.workleap-dev.com:6091",
    navigationApiBaseUrl: "https://api.platform.workleap-dev.com/shell/navigation/",
    managementAppBaseUrl: "https://management.workleap-dev.com",
    wlAppBaseUrl: "https://app.workleap-stg.com",
    cdnBaseUrl: "https://cdn.ai.workleap-dev.com",
    navigationBarEnvironment: "development",
    loginPageUrl: "https://login.workleap-dev.com",
    intercomAppId: "gw56e358"
};

const DevelopmentEnvironmentVariables: EnvironmentVariables = {
    aiApiBaseUrl: "https://api.ai.workleap-dev.com/backend",
    navigationApiBaseUrl: "https://api.platform.workleap-dev.com/shell/navigation/",
    managementAppBaseUrl: "https://management.workleap-dev.com",
    wlAppBaseUrl: "https://app.workleap-stg.com",
    cdnBaseUrl: "https://cdn.ai.workleap-dev.com",
    navigationBarEnvironment: "development",
    loginPageUrl: "https://login.workleap-dev.com",
    intercomAppId: "gw56e358",
    openTelemetryProxyUrl: "https://api.officevibe.workleap-dev.com/authentication-proxy/proxy/otel"
};

const StagingEnvironmentVariables: EnvironmentVariables = {
    aiApiBaseUrl: "https://api.ai.workleap-stg.com/backend",
    navigationApiBaseUrl: "https://api.platform.workleap-stg.com/shell/navigation/",
    managementAppBaseUrl: "https://management.workleap-stg.com",
    wlAppBaseUrl: "https://app.workleap-stg.com",
    cdnBaseUrl: "https://cdn.ai.workleap-stg.com",
    navigationBarEnvironment: "staging",
    loginPageUrl: "https://login.workleap-stg.com",
    intercomAppId: "gw56e358",
    openTelemetryProxyUrl: "https://api.officevibe.workleap-stg.com/authentication-proxy/proxy/otel"
};

const ProductionEnvironmentVariables: EnvironmentVariables = {
    aiApiBaseUrl: "https://api.ai.workleap.com/backend",
    navigationApiBaseUrl: "https://api.platform.workleap.com/shell/navigation/",
    managementAppBaseUrl: "https://management.workleap.com",
    wlAppBaseUrl: "https://app.workleap.com",
    cdnBaseUrl: "https://cdn.ai.workleap.com",
    navigationBarEnvironment: "production",
    loginPageUrl: "https://login.workleap.com",
    intercomAppId: "cybcvgei",
    openTelemetryProxyUrl: "https://api.officevibe.workleap.com/authentication-proxy/proxy/otel",
    logRocketAppId: "27bhmd/workleap"
};

export const getEnvironmentVariables = (env: Environment): EnvironmentVariables => {
    switch (env) {
        case "msw":
            return MswEnvironmentVariables;
        case "local":
            return LocalEnvironmentVariables;
        case "development":
            return DevelopmentEnvironmentVariables;
        case "staging":
            return StagingEnvironmentVariables;
        case "production":
            return ProductionEnvironmentVariables;
        default:
            throw new Error("Invalid environment");
    }
};
